import script from "./SavedSearchesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SavedSearchesComponent.vue?vue&type=script&setup=true&lang=js"

import "./SavedSearchesComponent.vue?vue&type=style&index=0&id=2d7d255b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7d255b"]])

export default __exports__